/* eslint-disable react/no-unknown-property */
import { Link } from "@quintype/components";
import { object } from "prop-types";
import { useSelector } from "react-redux";
import get from "lodash/get";
import React from "react";

import { SvgIconHandler } from "../../../../atoms/svg-icon-hadler";

import "./bread-crumbs.m.css";

function getParentSections(section, sectionsArr) {
  const result = [];
  const parentSection = sectionsArr.find((item) => item.id === section["parent-id"]);
  result.push(parentSection);
  if (parentSection["parent-id"] === null) {
    return result;
  } else {
    return [...result, ...getParentSections(parentSection, sectionsArr)];
  }
}

const Breadcrumbs = ({ story }) => {
  if (!story) {
    return null;
  }

  const sectionInfo = get(story, ["sections", "0"]);
  const sections = useSelector((state) => get(state, ["qt", "config", "sections"], []));
  const isPhotoStory = get(story, ["story-template"]) === "photo";
  const photoStoryStyle = isPhotoStory ? "photo-story-style" : "";
  const crumsList = sectionInfo["parent-id"]
    ? [sectionInfo, ...getParentSections(sectionInfo, sections)].reverse()
    : [sectionInfo];

  return (
    <div styleName={`breadcrumbs ${photoStoryStyle}`} data-test-id="breadcrumbs" className="breadcrumb-wrapper">
      <Link href="/" aria-label="home page" data-test-id="home-section">
        <SvgIconHandler type="home-icon" width="24" height="24" viewBox="0 0 24 24" />
      </Link>
      <SvgIconHandler className="chevron" type="down-chevron" width="24" height="24" viewBox="0 0 12 12" />
      {crumsList &&
        crumsList.map((breadCrum, index) => (
          <>
            <Link
              href={`/${crumsList
                .map((item) => item.slug)
                .slice(0, index + 1)
                .join("/")}`}
              aria-label="parent-section"
              data-test-id="parent-section"
            >
              {breadCrum["display-name"] || breadCrum.name}
            </Link>
            {crumsList.length - 1 !== index && (
              <SvgIconHandler className="chevron" type="down-chevron" width="24" height="24" viewBox="0 0 12 12" />
            )}
          </>
        ))}
    </div>
  );
};

Breadcrumbs.propTypes = {
  story: object,
};

export default Breadcrumbs;
